<template>
	
	<div class="pt-10 pb-10" id="posts-blog">

		<h1 class="text-center">¡Enterate!</h1>

		<p style="text-align: center;color: gray;font-weight: bold;text-transform: uppercase;">
    	<small>¡Informate de las ultimas novedades que tenemos para ti!</small>
    </p>

	  <v-container>

	    <v-row id="posts-desktop">

	      <v-col lg="3" sm="6" cols="12" v-for="post in posts">

	        <v-card class="mx-auto pb-5 mt-5">
	          <v-img
	            class="white--text align-end"
	            height="200px"
	            :src="backend+'../storage/app/'+post.img"
	          >
	        	</v-img>

	          <v-card-subtitle class="pb-0 text-center">
	            <h3>{{post.title}}</h3>
	          </v-card-subtitle>

	          <v-card-text class="text--primary mt-4">
	            <p class="mb-3 post-content">
	              <b>{{post.introduction}}</b>
	            </p>
	            <p class="text-right ma-0" style="color: gray;">
	            	<small><b><i>{{ dateFormat2(post.created_at) }}</i></b></small>
	            </p>
	          </v-card-text>

	          <div class="text-center" style="margin-top: -10px">
	            <v-btn color="secondary" tile :to="'/post/'+post.id">
	              Ver mas
	            </v-btn>
	          </div>
	            
	        </v-card>

	      </v-col>

	    </v-row>


	    <div class="text-center" v-if="postsEmpty">
	    	<v-icon size="200">mdi-post</v-icon>
	    	<h4 style="text-transform: uppercase;">No hay post por los momentos...</h4>
	    </div>

	  </v-container>

	</div>

</template>



<style scoped>
	
	#posts-blog {
		background: #f4f4f4;
	}

	.post-content {
		text-align: justify;
		color: gray;
	}

</style>



<script>
	
	import BlogService from '@/shared/services/BlogService'

	export default
	{
		data() {
			return {
				posts: [],
				postsEmpty: false
			}
		},

		created() {
			this.getPosts()
		},

		methods: {

			async getPosts()
			{
				const resp = await BlogService.get()
				this.posts = resp.data

				if(this.posts.length == 0)
					this.postsEmpty = true
			},


			dateFormat2(date)
			{
			  let d = new Date(date)
			  let months = Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');


			  let month = months[d.getMonth()]
			  let day = d.getDate().toString().padStart(2,'0')
			  let year = d.getFullYear()


			  return day + ' de ' + month + ' del ' + year
			}

		}

	}

</script>